const downloadInstallerOnline = (httpClient, os) => {
    return httpClient.get(`endpoint-security/download`, {params: {os: os }})
      .then(res => res.data)
}

const getOSList = (httpClient) => {
    return httpClient.get(`endpoint-security`)
      .then(res => res.data)
  }


export default {
    downloadInstallerOnline,
    getOSList
}